import { RecipientRole } from '@getaccept/lib-shared/src/recipients/types/enums/recipient-role';
import type { SigningPageRecipient } from '@getaccept/lib-shared/src/types/signing-page-recipient';
export class RecipientHelper {
  static getViewableRecipients(
    { role: currentRecipientRole }: SigningPageRecipient,
    recipients: SigningPageRecipient[]
  ): any[] {
    if (currentRecipientRole === RecipientRole.Approver) {
      return recipients;
    }

    const nonApprovers: SigningPageRecipient[] = this.removeApprovers(recipients);

    if (!nonApprovers?.length) {
      return [];
    }

    return this.removeOrderNumberGaps(nonApprovers);
  }

  static removeOrderNumberGaps(recipients: SigningPageRecipient[]): SigningPageRecipient[] {
    const groupedRecipients: {
      [key: string]: SigningPageRecipient[];
    } = this.groupByOrderNum(recipients);

    return Object.keys(groupedRecipients).reduce(
      (recipients: SigningPageRecipient[], key: string, index: number) => {
        const recipientsCorrected: SigningPageRecipient[] = groupedRecipients[
          key
        ].map((recipient: SigningPageRecipient) => ({ ...recipient, orderNum: index + 1 }));
        return [...recipients, ...recipientsCorrected];
      },
      []
    );
  }

  static groupByOrderNum(
    recipients: SigningPageRecipient[]
  ): {
    [key: string]: SigningPageRecipient[];
  } {
    return recipients.reduce(
      (acc: { [key: string]: SigningPageRecipient[] }, recipient: SigningPageRecipient) => ({
        ...acc,
        [recipient.orderNum]: (acc[recipient.orderNum] || []).concat(recipient),
      }),
      {}
    );
  }

  private static removeApprovers(recipients: SigningPageRecipient[]): SigningPageRecipient[] {
    return recipients
      .filter(({ role }: SigningPageRecipient) => role !== RecipientRole.Approver)
      .sort(
        (
          { orderNum: aOrderNum }: SigningPageRecipient,
          { orderNum: bOrderNum }: SigningPageRecipient
        ) => (aOrderNum < bOrderNum ? -1 : 1)
      );
  }
}
